export default "__VITE_ASSET__DVlTqeBC__"